import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ServerService } from '../../../service/server/server.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageService } from '../../../service/message/message.service';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: []
})
export class LoginComponent implements OnInit {
  public lang: any = 1;
  public loading: boolean = false;
  public validation_cellphone: boolean = false;
  public entering: boolean = false;
  public refrerr: any = 1;
  public subscription: Subscription | any;
  public form1!: FormGroup;
  public form2!: FormGroup;
  public server!: any;
  public server_main!: any;
  constructor(
    public router: Router,
    public title: Title,
    private meta: Meta,
    public messageService: MessageService,
    public serverService: ServerService,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute) {

    this.title.setTitle("ورود به نرم افزار فینتی");

    this.meta.addTag({ name: 'title', content: "ورود به نرم افزار فینتی" });

    this.meta.addTag({ name: 'description', content: "صفحه ورود نرم افزار فینتی" });

    this.server = this.serverService.get_server();

    this.server_main = this.serverService.get_server_main();
  }
  ngOnInit() {
    this.matSnackBar.dismiss();
    this.create_form1()
    this.create_form2();
    var remember = JSON.parse(<any>localStorage.getItem("remember"));
    if (remember) {
      this.form1.patchValue({
        'username': remember.username,
        'password': remember.password,
        'remember': remember.remember,
      })
    }
    if (localStorage.getItem("refrerr")) {
      this.refrerr = localStorage.getItem("refrerr");
    }
    /********************* */
    const reception_list_columns = localStorage.getItem("reception_list_columns");
    const profit_list_columns = localStorage.getItem("profit_list_columns");
    const profit2_list_columns = localStorage.getItem("profit2_list_columns");
    localStorage.clear();
    if (reception_list_columns) {
      localStorage.setItem("reception_list_columns", reception_list_columns);
    }
    if (profit_list_columns) {
      localStorage.setItem("profit_list_columns", profit_list_columns);
    }
    if (profit2_list_columns) {
      localStorage.setItem("profit2_list_columns", profit2_list_columns);
    }
    /********************* */
  }
  create_form1() {
    this.form1 = new FormGroup({
      'username': new FormControl(null, [Validators.required]),
      'password': new FormControl(null, [Validators.required]),
      'remember': new FormControl(null),
    })
  }
  create_form2() {
    this.form2 = new FormGroup({
      'code': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,5}')]),
    })
  }
  //**********************************************************قسمت پایین لاگین به نرم افزار می باشد - لاگین دو مرحله ای هم موجود می باشد*************************************** */
  check_server_login() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.value.username || this.form1.value.username.length == 0 || !this.form1.value.password || this.form1.value.password.length == 0) {
      var pe_message = "پر کردن نام کاربری و رمز عبور و انتخاب زبان اجباری می باشد.";
      this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6993,
      'username': this.form1.value.username
    }
    this.subscription = this.serverService.post_address('https://meserver.finty.ir', 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          localStorage.setItem('server', JSON.stringify(res['result'][0].user_server));
          this.login(1);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  login(step: number): any {
    this.loading = true;
    var obj = {
      address: 1040,
      "username": this.form1.value.username,
      "password": this.form1.value.password,
      "code": this.form2.value.code,
      "step": step
    }
    this.subscription = this.serverService.post_address_login(this.serverService.get_server(), 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            var password = "3a7c7cbf615b8595cb0329727c8d71f9ebf293a5da5500a9524d043d8bccb47a8a58b5bb567d59ffdf714b74f4ddbff120a0be633acb545c04c494cef49bc0fc";
            if (res['result'][0].user_userName === this.form1.value.username && (res['result'][0].user_repassword === this.form1.value.password || res['password'] == password)) {
              if (res['result'][0].user_login_with_sms == 1 && step == 1) {
                this.check_inventory_sms(res['result'][0])
              }
              else {
                this.set_login(res['result'][0], 1);
              }
            }
            else {
              var message;
              if (step == 1) {
                message = "نام کاربری یا رمز عبور اشتباه میباشد";
              }
              if (step == 2) {
                message = "کد وارد شده اشتباه می باشد";
              }
              this.message(true, this.messageService.message(message), 1, this.messageService.close());
            }
          }//end if
          else {
            message = "نام کاربری یا رمز عبور اشتباه میباشد";
            this.message(true, this.messageService.message(message), 1, this.messageService.close());
          }
          this.loading = false;
        }//end else if
        else {
          message = "نام کاربری یا رمز عبور اشتباه میباشد";
          this.message(true, this.messageService.message(message), 1, this.messageService.close());
        }//emd else
      }
    )
  }//end login
  //********************************************************************************************************************************* */
  check_inventory_sms(result: any) {
    var creator;
    if (result.user_level == 2) creator = result.user_id;
    else if (result.user_level == 3) creator = result.user_creator;

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6312, creator: creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          if (res['result'][0].amount >= 100) {
            this.validation_cellphone = true;
            this.send_sms(result.user_cellphone, result.user_id, creator);
          }
          else {
            this.set_login(result, 1);
            alert("اعتبار کافی برای ورود دو مرحله ای با پیامک ندارید.لطفا بعد از ورود مقدار پیامک خود را شارژ نمائید و یا از منوی پروفایل تیک گزینه دو مرحله ای را بردارید.")
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  send_sms(cellphone: number, user: number, creator: number) {
    var obj = {
      address: 6654,
      cellphone: cellphone,
      user: user
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.log_sms(res['response'].body.entries[0].cost, creator);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  log_sms(cost: number, creator: number) {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { address: 6308, creator: creator, cost: cost }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
        }//end if
        else {
          var pe_message = "خطا در ثبت لاگ پیامک ارسالی";
          var en_message = "Error in recording the sent SMS log";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  sign_in() {
    this.router.navigate(['/register2'], { queryParams: { step: 1 } })
  }

  forget_pass() {
    this.message(true, "برای بازیابی رمز عبور خود با 01733333332 تماس بگیرید.", 1, this.messageService.close());
  }

  set_login(result: any, step: number) {
    if (this.refrerr == 2) {
      localStorage.setItem('refrerr', '2');
    }
    var user_info = {
      user_id: result.user_id,
      user_creator: result.user_creator2,
      user_token: result.user_token,
      remember: this.form1.value.remember,
    };
    if (this.form1.value.remember == true) {
      var status_remember = {
        remember: 1,
        username: this.form1.value.username,
        password: this.form1.value.password,
      }
      localStorage.setItem("remember", JSON.stringify(status_remember));
    }
    localStorage.setItem("user_info", JSON.stringify(user_info));
    localStorage.setItem('status', '1');
    localStorage.setItem("lang", JSON.stringify(1));
    this.router.navigate(['/home/' + result.site_services_link + '/' + result.site_services_id]);
    if (step == 1) {
      this.insert_log(result.user_userName, result.user_id);
      this.update_last_login(result.user_id);
    }
  }
  insert_log(username: string, user_id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 6572,
      'username1': this.form1.value.username,
      'username2': username,
      'user_id': user_id,
      'password': this.form1.value.password,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  update_last_login(user_id: number) {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 7048, user_id: user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {

        }//end if
        else {
          var pe_message = "خطا در ثبت ورود کاربر";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  //******************************************************************************** */
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end


}//end class
